import { Component, OnInit, ViewChild } from '@angular/core';
import { getErrorMessage } from '@utils';
import { firstValueFrom } from 'rxjs';
import { MessageService } from '../../../services/message.service';
import { NotasFiscaisService } from '../../../services/notas-fiscais.service';
import { PedidosService } from '../../../services/pedidos.service';
import { UnidadesEmpresaParametrosService } from '../../../services/unidades-empresa-parametros.service';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';

@Component({
  selector: 'app-modal-acompanhamento-nfe-do-pedido',
  templateUrl: './modal-acompanhamento-nfe-do-pedido.component.html',
  styleUrls: ['./modal-acompanhamento-nfe-do-pedido.component.scss']
})
export class ModalAcompanhamentoNfeDoPedidoComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal;

  pedidos = [];
  gerouNfe = false;
  parametrosNfe = null;

  constructor(
    private messageService: MessageService,
    private pedidosService: PedidosService,
    private notasFiscaisService: NotasFiscaisService,
    private unidadeEmpresaParametrosService: UnidadesEmpresaParametrosService
  ) {
    super();
  }

  ngOnInit() {
    this.carregarParametros();
  }

  async carregarParametros() {
    try {
      this.loading['parametros'] = true;
      this.parametrosNfe = await firstValueFrom(this.unidadeEmpresaParametrosService.getParametrosNfe());
    } catch (err) {
      this.messageService.error('Falha ao carregar parâmetros: ' + getErrorMessage(err), 8000);
    } finally {
      this.loading['parametros'] = false;
    }
  }

  show() {
    this.pedidos = this.prop.pedidos;
    this.pedidos.sort((a, b) => a.numeroPedido - b.numeroPedido);

    this.modal.show();
  }

  onClose() {
    this.closed.emit({
      gerouNfe: this.gerouNfe,
      pedidosFaturados: this.pedidos.filter(x => x.statusNfe === 'A').map(x => x.id),
    });
  }

  async gerarNfe() {
    try {
      this.gerouNfe = true;
      this.loading['gerarNfe'] = true;

      for (const pedido of this.pedidos) {
        try {
          pedido.statusNfe = '0'; // Não enviada

          // Acho que o ideal era gerar todas as NF-e de uma vez, mas as validações usando NotificarErro no 
          // backend atrapalham nesse caso, pois não retornam erros por pedido. Como tem validações desse tipo
          // até na consulta da Automação, acabei mudando para geração individual.
          const geracaoNfe = await firstValueFrom(this.pedidosService.faturarPedidoParaNfe(pedido.id));
          if (!geracaoNfe.nfeId) {
            pedido.statusNfe = 'E'; // Erro
            pedido.erro = 'Nota não gerada por erro desconhecido.';
            continue;
          }
          
          pedido.numeroNfe = geracaoNfe.numeroNfe;
          pedido.nfeId = geracaoNfe.nfeId;

          const emissao = await firstValueFrom(this.notasFiscaisService.enviarNfe(geracaoNfe.nfeId));
          if (emissao?.erros) { // Quando houve retorno de erros na classe de Enviar NFe
            pedido.statusNfe = 'E'; // Erro
            pedido.erro = emissao.erros.join(' | ');
            continue;
          }
          if (!emissao?.nfeId) {
            pedido.statusNfe = 'E'; // Erro
            pedido.erro = 'Nota não enviada por erro desconhecido.';
            continue;
          }

          pedido.statusNfe = 'A'; // Autorizada

          if (emissao?.nfeId && this.parametrosNfe?.envioEmailAutomatico) {
            try {
              pedido.statusEmail = 'ENVIANDO';

              const emitirBoletos = !!this.parametrosNfe?.enviarAutomaticamenteBoleto;
              await firstValueFrom(this.notasFiscaisService.enviarEmail(emissao.nfeId, null, emitirBoletos));

              pedido.statusEmail = 'OK';
            } catch (errEmail) {
              pedido.statusEmail = 'ERRO';
              pedido.erroEmail = getErrorMessage(errEmail);
            }
          }
        } catch (err) {
          pedido.statusNfe = 'E'; // Erro
          pedido.erro = getErrorMessage(err);
        }
      }

      if (this.pedidos.some(x => x.statusNfe === 'E' || x.statusEmail === 'ERRO')) {
        this.messageService.warning('Faturamento concluído com erros.', 5000, null);
      } else {
        this.messageService.success('Faturamento concluído.', 5000);
      }
    } catch (error) {
      this.messageService.error(getErrorMessage(error));
    } finally {
      this.loading['gerarNfe'] = false;
    }
  }
}
